module.exports = __webpack_public_path__ + "img/bw.d1585fdf.svg";